<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-prologue element-with-heading" id="prologue">
<div class="heading heading-with-title heading-without-image" id="prologue-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Prologue</h1>
</div>
</div>
</div>
</div>
<div class="text" id="prologue-text">
<p class="first first-in-chapter first-full-width"><span class="drop-cap">M</span>elanie watched the sea crash against the shore with an anger she’d only ever seen in humans. She timed her walks to catch each high tide; whether it was before the crack of dawn or hours after. She did the normal things as best as she could. She’d make trips to the small town shops to buy her bread and milk, always in cash. During each trip she made idle conversation with the ice cream and souvenir shop owners, who complained religiously about the perils of closed season. Melanie smiled knowingly, as though she could understand their plight somehow.</p>
<p class="subsq">‘Feeling settled now?’ one of them asked as she tried to walk away.</p>
<p class="subsq">‘Oh, you know, things still feel new.’</p>
<p class="subsq">‘You’ll be a regular before you know it.’</p>
<p class="subsq">‘I’m hoping so,’ Melanie replied, thinking, <i>I’m hoping not</i>. ‘I better get going if I’m going to catch that sea drawing in.’</p>
<p class="subsq">‘Yep, you go ahead and get your fins wet, Kelly. Be seeing you.’</p>
<p class="subsq">‘Take care now,’ Melanie shouted back.</p>
<p class="subsq">The sea was furious and there was something comforting in its madness. Melanie imagined her own feelings being channelled through it somehow. She walked along the beach for as long as she could before froth and cold water began to lap at her feet, then she climbed the steps to the seafront. The wind was vicious too, and she was glad she’d brought a scarf. She was midway through her walk to the boats when she decided to call him.</p>
<p class="subsq">The seafront was dotted with benches, some of them were out in the open but some were tucked away inside small brick structures. The front of the building was open, but the shelters around the sides and the back would give Melanie the quiet she needed to make a phone call. She keyed in the right speed dial number and waited.</p>
<p class="subsq">‘DS Carter speaking.’</p>
<p class="subsq">The sound of his voice was more of a comfort than Melanie had expected it to be. She smiled, but the sensation of sea salt cracking on her lips brought home the situation. ‘It’s me.’</p>
<p class="subsq">She heard him sigh before he answered. ‘Christ, boss, is it good to hear you.’</p>
<p class="subsq">‘Is everything okay?’</p>
<p class="subsq">There was a long spill of silence before Carter replied. She pressed the phone hard against her ear in case the wind had snatched his reply away.</p>
<p class="subsq">‘Everything’s fine,’ he said after a few seconds. ‘It’s just been… It’s been a day.’</p>
<p class="subsq">‘You can’t say?’ Melanie knew the answer before she’d even asked the question. It was an ongoing investigation; of course Carter couldn’t say. But she was desperate to know all the same.</p>
<p class="subsq">‘I shouldn’t say.’</p>
<p class="subsq">Yet, from his tone, Melanie had a feeling he would…</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// prologue.vue?117fe48c